import React, {PureComponent} from 'react';
import {Icon} from '@material-ui/core';

class ResponsePanelHeader extends PureComponent {
    state = {};

    componentDidUpdate(prevProps) {
        const isFetching = this.props.response && this.props.response.fetching;
        const wasFetching = prevProps.response && prevProps.response.fetching;
        if (isFetching !== wasFetching) {
            if (isFetching) {
                this.setState({
                    currentTime: this.props.response.startTime
                });
                this._updateTimer = setInterval(this._updateTimes, 1000);
            } else {
                clearInterval(this._updateTimer);
            }
        }
        if (isFetching && wasFetching && this.props.response.startTime !== prevProps.response.startTime) {
            clearInterval(this._updateTimer);
            this.setState({
                currentTime: this.props.response.startTime
            });
            this._updateTimer = setInterval(this._updateTimes, 1000);
        }
    }

    render() {
        let status = null;
        let timing = null;
        if (this.props.response) {
            const {fetching, fetchError, startTime, endTime, errors} = this.props.response;
            if (fetchError) {
                status = (
                    <div className="response-status response-status-error">
                        <Icon>error</Icon>
                        Failed
                    </div>
                );
            } else if (fetching) {
                status = (
                    <div className="response-status response-status-pending" style={{transitionDuration: '500ms'}}>
                        <Icon>swap_vertical_circle</Icon>
                        Pending
                    </div>
                );
            } else if (errors && errors.length > 0) {
                status = (
                    <div className="response-status response-status-error">
                        <Icon>warning</Icon>
                        Errors
                    </div>
                );
            } else {
                status = (
                    <div className="response-status response-status-success">
                        <Icon>check_circle</Icon>
                        OK
                    </div>
                );
            }
            timing = (
                <div className="response-status response-status-muted">
                    <Icon>timer</Icon>
                    {getTimerString(startTime, endTime ? endTime : this.state.currentTime, !endTime)}
                </div>
            );
        }
        return (
            <div className="response-panel-header">
                {status}
                {timing}
            </div>
        )
    }

    _updateTimes = () => {
        this.setState({
            currentTime: window.performance.now()
        });
    };
}

function getTimerString(startTime, endTime, partial) {
    const milliseconds = endTime - startTime;
    let prefix;
    let number;
    if (milliseconds > 1000 || partial) {
        number = (milliseconds / 1000).toFixed(partial ? 0 : 2);
        prefix = 's';
    } else {
        number = milliseconds.toFixed(0);
        prefix = 'ms';
    }
    return `${number}${prefix}`;
}

export default ResponsePanelHeader;



// WEBPACK FOOTER //
// ./src/components/ResponsePanelHeader.js